import "./styles/IconButton.scss";

interface IProps extends React.HTMLAttributes<HTMLButtonElement> {
    icon: JSX.Element;
    opened: boolean;
    onClick: () => void;
    ariaLabel?: string;
}

const IconButton = ({ icon, opened, onClick, ariaLabel }: IProps) => {
    return (
        <button
            aria-label={ariaLabel}
            className={`${
                opened ? "icon-button icon-button--opened" : "icon-button"
            }`}
            onClick={onClick}
        >
            {icon}
        </button>
    );
};
export default IconButton;
